module.exports = __webpack_public_path__ + "img/nb.26e9e5d5.svg";